// Screen-size switches the layout reads, one listener each for the whole
// app rather than one per component.
//
// The widths are Arco's own breakpoints, so a view's responsive props
// (`:span="{ xs: 24, md: 12 }"`, `:column="{ xs: 1, lg: 2 }"`) and these
// switches change at the same widths:
//   narrow — below lg (992px). Arco Design Pro hides the side menu here
//            and opens it as a drawer from the navbar instead.
//   phone  — below md (768px). Forms stack their labels, dialogs take the
//            screen's width (see styles/mobile.css).
import { readonly, ref } from 'vue'

function media(query: string) {
  const mql = window.matchMedia(query)
  const on = ref(mql.matches)
  mql.addEventListener('change', (e) => (on.value = e.matches))
  return readonly(on)
}

export const isNarrow = media('(max-width: 991px)')
export const isPhone = media('(max-width: 767px)')
